import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

interface PasswordInputProp {
  onBlur?: (event: any) => void;
  showLost: boolean;
}

interface PasswordInputState {
  showPassword: boolean;
}

export default class PasswordInput extends React.Component<PasswordInputProp, PasswordInputState> {
  state: PasswordInputState = { showPassword: false };

  render(): React.ReactNode {
    const { showPassword } = this.state;

    return (
      <>
        <label className="inputLabel" htmlFor="login-password">
          {this.props.showLost ? 'Passwort' : 'Neues Passwort'}:{' '}
          {this.props.showLost ? (
            <a
              style={{ cursor: 'pointer' }}
              onClick={() => {
                (window as any).historyHelper.memory.push('/login?action=lost', null);
              }}
            >
              <span style={{ fontWeight: 'bold', color: '#c20f0d' }}>(vergessen?)</span>
            </a>
          ) : null}
        </label>
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            name="password"
            id="login-password"
            size={36}
            maxLength={255}
            onBlur={(ev) => {
              if (this.props.onBlur != undefined) this.props.onBlur(ev);
            }}
          />
          <span
            onClick={() => this.setState({ showPassword: !showPassword })}
            title={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
              color: '#555',
            }}
          >
            <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
          </span>
        </div>
        <br className="clearBoth" />
      </>
    );
  }
}
